import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  eventText: {
    ...theme.fonts.label,
    listStyleType: 'none',
  },
}));

interface Props {
  changedProperties: string[];
  status: string;
}

const filtred = ['version', 'updatedAt', 'createdAt', 'publishedAt'];

export const SessionChangedHistoryText = ({
  status,
  changedProperties,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const filteredChangedProperties = changedProperties.filter(
    (property) => !filtred.includes(property),
  );

  return (
    <ul className={classes.eventText}>
      {filteredChangedProperties.map((property) => (
        <li>
          {t('eventHistory.SessionUpdated.name', {
            context: property,
            property,
            status,
          })}
        </li>
      ))}
      {filteredChangedProperties.length === 0 && (
        <li>{t('eventHistory.SessionUpdated.empty')}</li>
      )}
    </ul>
  );
};
